<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentt"><span class="bold">Portuguese National Cemeteries</span></p>
<p class="noindent">The single Portuguese cemetery at Neuve Chapelle is administered by the <span class="bold"><em class="italic">Union Franco-Portuguaise</em></span> located at 61, Rue des Haies at Richebourg. The cemetery has suffered in the past from neglect and many of the headstones are in very poor condition and very difficult to read. Sadly, over 200 of the headstones mark the graves of unknown – <em class="italic">disconhecido</em> – soldiers.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14_fm029.vue?1f199c2d